import React from "react";

export const faqs = [
  {
    question: "Are the diamonds certified?",
    answer:
      "Yes, all our diamonds are certified by reputable gemological laboratories like GIA, IGI, and HRD. You will receive a certificate with each diamond you purchase.",
  },
  {
    question: "How can I ensure the diamond is authentic?",
    answer:
      "We provide authenticity certificates and allow third-party verification. Our diamonds are ethically sourced and verified for quality and origin.",
  },
  {
    question: "What is your return / refund policy?",
    answer:
      "All products sold on JPS Jewels are non-refundable. Jewellery, diamonds, customized items, and downloadable design files cannot be cancelled, returned, exchanged, or refunded after successful payment. Refunds are made only for duplicate payments, technical failures where an order is not generated, or if we are unable to deliver — see our <a href='/refundpolicy'>Refund & Cancellation Policy</a> for details.",
  },
  {
    question: "Do you offer resizing or customization?",
    answer:
      "Yes, we offer free ring resizing and custom jewelry design services. Reach out to our support team with your requirements.",
  },
  {
    question: "Can I visit a physical store?",
    answer:
      "Yes, you can visit our showroom by appointment. Contact our customer support to book a time that suits you.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit/debit cards, net banking, UPI, and EMI options. Transactions are secured through trusted payment gateways.",
  },
  {
    question: "Is my purchase insured during shipping?",
    answer:
      "Yes, all shipments are insured until they reach you. In the rare case of loss during transit where we are unable to deliver your order, you will receive a replacement or a refund as per our Refund & Cancellation Policy.",
  },
  {
    question: "Do you offer international shipping?",
    answer:
      "Yes, we ship internationally with secure and insured delivery partners. Shipping times and charges vary by country.",
  },
  {
    question: "Can I track my order?",
    answer:
      "Yes, once your order is shipped, you’ll receive a tracking link via email or SMS. You can also check your order status in your account.",
  },
  {
    question: "How do I contact customer support?",
    answer:
      "You can reach us via email at <a href='mailto:mail@jpsjewels.com'>mail@jpsjewels.com</a>.",
  },
];

const FAQ = () => {
  return (
    <div className="policy-container">
      <h3 className="policy_title"> Frequently Asked Questions</h3>
      {faqs.map((faq, index) => (
        <React.Fragment key={index}>
          <h3 className="policy-title">{faq.question}</h3>
          <ul className="policy-list">
            <li dangerouslySetInnerHTML={{ __html: faq.answer }} />
          </ul>
        </React.Fragment>
      ))}
    </div>
  );
};

export default FAQ;
